// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone-verification {
  margin-top: 15px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.phone-verification.verified {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.verified-icon {
  color: #155724;
  font-size: 20px;
  margin-right: 10px;
}

.verified-text {
  color: #155724;
  font-weight: 500;
}

.verification-message {
  margin-bottom: 15px;
  color: #495057;
  text-align: center;
}

.verify-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
  display: block;
  margin: 0 auto;
}

.verify-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.verify-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.65;
}

.code-input-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.code-input {
  width: 120px;
  padding: 10px;
  font-size: 20px;
  text-align: center;
  letter-spacing: 8px;
  border: 2px solid #ced4da;
  border-radius: 5px;
  transition: border-color 0.2s;
}

.code-input:focus {
  outline: none;
  border-color: #007bff;
}

.resend-container {
  text-align: center;
  margin-top: 10px;
}

.resend-timer {
  color: #6c757d;
  font-size: 14px;
}

.resend-link {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  padding: 0;
}

.resend-link:hover:not(:disabled) {
  color: #0056b3;
}

.resend-link:disabled {
  color: #6c757d;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/PhoneVerification.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".phone-verification {\n  margin-top: 15px;\n  padding: 20px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.phone-verification.verified {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n}\n\n.verified-icon {\n  color: #155724;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.verified-text {\n  color: #155724;\n  font-weight: 500;\n}\n\n.verification-message {\n  margin-bottom: 15px;\n  color: #495057;\n  text-align: center;\n}\n\n.verify-button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.2s;\n  display: block;\n  margin: 0 auto;\n}\n\n.verify-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.verify-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.code-input-container {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.code-input {\n  width: 120px;\n  padding: 10px;\n  font-size: 20px;\n  text-align: center;\n  letter-spacing: 8px;\n  border: 2px solid #ced4da;\n  border-radius: 5px;\n  transition: border-color 0.2s;\n}\n\n.code-input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.resend-container {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.resend-timer {\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.resend-link {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: 14px;\n  padding: 0;\n}\n\n.resend-link:hover:not(:disabled) {\n  color: #0056b3;\n}\n\n.resend-link:disabled {\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: #dc3545;\n  text-align: center;\n  margin-top: 10px;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
